import { render, staticRenderFns } from "./DatasetTypeDialog.vue?vue&type=template&id=798409a4&scoped=true"
import script from "./DatasetTypeDialog.vue?vue&type=script&lang=js"
export * from "./DatasetTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./DatasetTypeDialog.vue?vue&type=style&index=0&id=798409a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798409a4",
  null
  
)

export default component.exports